/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { white } from 'crehana-ui/styles/colors';

import { CourseCardProps } from 'Jsx/Shared/CourseCardV3/types';
import PlayArrow from 'crehana-icons/PlayArrow';
import EyeOutline from 'crehana-icons/EyeOutline';
import TextLink from 'crehana-ui/Buttons/TextLink';

import LazyImage from 'Jsx/Shared/LazyImage/v3/LazyImage';
import LazyImageResponsive from 'Jsx/Shared/LazyImage/v3/LazyImageResponsive';

import { ImgxParams } from 'Jsx/Types/ImgxParams';

const Image: React.FC<Partial<CourseCardProps>> = props => {
  const {
    children,
    lazyImageProps,
    responsiveImage,
    lazyImage = true,
    hidePreview,
    ...rest
  } = props;
  const imgxParams: ImgxParams = {
    w: 322,
    h: 219,
    ...rest.imgxParams,
  };

  const showPreview = e => {
    e.preventDefault();
    if (window.showCoursePreview && !hidePreview) {
      window.showCoursePreview(props);
    } else if (rest.url) {
      window.location.href = rest.url;
    }
  };

  const onClickImage = event => {
    if (props.customOnClickImage) {
      event.preventDefault();
      // only run if it come from the props
      props.customOnClickImage(event);
    }
  };

  return (
    <a
      href={rest.url ? rest.url : ''}
      onClick={onClickImage}
      className="ImageComponent block"
      arial-label={rest.title}
    >
      <div
        className="ImageComponentWrapper relative"
        css={`
          &:hover {
            .before-preview {
              opacity: 0;
            }
          }
          .before-preview {
            z-index: 3;
            opacity: 1;
            &:hover {
              opacity: 0;
              transition: ease-in 0.3s;
            }
          }
          .preview {
            z-index: 4;
            opacity: 0;
            &:hover {
              opacity: 1;
              transition: ease-in 0.3s;
            }
          }}
          @media (min-width: 1140px) {
            height: ${!lazyImage ? '182px' : 'unset'};
          }
        `}
      >
        {!hidePreview && (
          <>
            <div
              onClick={showPreview}
              onKeyPress={showPreview}
              className="hidden w-full h-full md:flex items-center justify-center absolute bg-base-main-80 preview"
            >
              <EyeOutline size={24} color="#fff" />
              <TextLink className="ml-8" type="level1" color="white">
                Ver Trailer
              </TextLink>
            </div>
            <div className="hidden w-full h-full md:flex items-center justify-center absolute before-preview">
              <div
                style={{
                  width: 32,
                  height: 32,
                  backgroundColor: 'rgba(75, 34, 244, 0.6)',
                }}
                className="flex items-center justify-center rounded-full"
              >
                <PlayArrow size={18} color={white} />
              </div>
            </div>
          </>
        )}
        {responsiveImage ? (
          <LazyImageResponsive
            placeholder={rest.imagePlaceholder}
            imgxParams={rest.imgxParams}
            css={`
              height: auto;
              padding-bottom: 70%;
            `}
            alt={rest.title as string}
            className="course-image"
            {...lazyImageProps}
          />
        ) : (
          <LazyImage
            placeholder={rest.imagePlaceholder}
            src={(rest.promoImageAnimated || rest.promoImage) as string}
            imgxParams={imgxParams}
            css={`
              height: auto;
              padding-bottom: 70%;
            `}
            alt={rest.title as string}
            className="course-image"
            {...lazyImageProps}
          />
        )}
        {React.Children.toArray(children).map(child =>
          React.cloneElement(child as React.ReactElement<any>, rest),
        )}
      </div>
    </a>
  );
};

export default Image;
